import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { selectDataSourcesLoading, selectDataSourcesValues } from 'services/Telematics/selectors';

// COMPONENTS
import { CanOrNotFound } from 'permissions';
import TelematicsCard from './cards/Device';
import DevicelessTelematicsCard from './cards/Deviceless';

// STYLES
import { SettingsPageContent } from 'styles/settings';

// CONSTANTS
import { DotAppRoute, FleetSettingsSideMenuItem, UserPermission } from 'constants/common';
import useStrategy, { FeatureFlags } from 'hooks/useStrategy';

// HOOKS
import { useAppDispatch } from 'hooks/store';

// SERVICES
import { listDataSources } from 'services/Telematics/thunks';
import { OEMNames } from 'constants/telematics';

const Telematics = () => {
  const intl = useIntl();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(listDataSources());
  }, [dispatch]);

  const oemTelematicsEnabled = useStrategy(FeatureFlags.OEM_TELEMATICS);
  const dataSources = useSelector(selectDataSourcesValues());
  const dataSourcesLoading = useSelector(selectDataSourcesLoading());

  // FLEET-2480: only display the "Direct Connect Telematics" section if there is a single datasource with oem === 'zubie'
  const onlyDataSourceIsZubieOEM = dataSources.length === 1 && dataSources[0].oemName === OEMNames.ZUBIE;

  return (
    <CanOrNotFound I={UserPermission.VIEW} a={DotAppRoute.SETTINGS} field={FleetSettingsSideMenuItem.TELEMATICS}>
      <SettingsPageContent>
        <Helmet>
          <title>
            {intl.formatMessage({
              id: 'views.Settings.helmetTitle',
            })}
          </title>
          <meta
            name="settings"
            content={intl.formatMessage({
              id: 'views.Settings.helmetDescription',
            })}
          />
        </Helmet>
        <TelematicsCard />
        {oemTelematicsEnabled && !dataSourcesLoading && (
          <DevicelessTelematicsCard
            dataSources={dataSources}
            dataSourcesLoading={dataSourcesLoading}
            onlyDataSourceIsZubieOEM={onlyDataSourceIsZubieOEM}
          />
        )}
      </SettingsPageContent>
    </CanOrNotFound>
  );
};

export default Telematics;
